export default {
    name: 'CiberSecurity',

    data() {
        return {};
    },

    computed: {
        environment() {
            return process.env.VUE_APP_ENV;
        },
        isLogged() {
            return this.$route.meta.guest ? false : true;
        }
    }
};
